import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/recipecard.css";
import fallbackImage from "../assets/images/torta.jpg";

export default function RecipeCard({ recipe }) {
  const [imgError, setImgError] = useState(false);

  const title = recipe.title || "Bez naslova";
  const description =
    recipe.description || "Bezglutenski recept – kliknite za detalje.";

  // 🖼️ LOGIKA ZA ODABIR SLIKE
  const image = !imgError
    ? recipe.image || recipe.recipe_images?.[0]?.image_url || fallbackImage
    : fallbackImage;

  return (
    <article className="recipe-card">
      <Link to={`/recipes/${recipe.id}`} aria-label={`Recept: ${title}`}>
        <div className="thumb">
          <img
            src={image}
            alt={title}
            loading="lazy"
            onError={() => setImgError(true)}
          />
        </div>

        <h3>{title}</h3>
        <p className="excerpt">{description}</p>
      </Link>
    </article>
  );
}
